export default "/images/4c514855c1f6f5c7e1a3207466cbdcf7.avif";